import React from "react";
import ReviewsSection from "../components/ReviewsSetion";
import { MainLayout } from "../styles/Layouts";

function TestimonialsPage() {
  return (
    <MainLayout>
      <ReviewsSection />
    </MainLayout>
  );
}

export default TestimonialsPage;
